import { makeCommunicationSelector } from 'shared/helpers/redux';
import makeSelectFeatureState from 'shared/helpers/redux/makeSelectFeatureState';

export const selectFeatureState = makeSelectFeatureState('DownloadFile');
export const selectCommunication = makeCommunicationSelector(selectFeatureState);
